import React from 'react'
import PropTypes from 'prop-types'
import QueryManager from './Query'
import gql from 'graphql-tag'
import { get } from 'lodash'

const GET_CUSTOMERS = gql`query getCustomers($size: Int, $page: Int, $sort: [SortInput], $filters: [FilterInput], $range: RangeInput) {
  customers(size: $size, page: $page, sort: $sort, filters: $filters, range: $range) {
    count
    page
    results {
      ... on Customer {
        id
        email
        createdIn
        updatedIn
        document
        first_name: firstName
        last_name: lastName
      }
    }
  }
}`

const onFetchMoreResponse = (previousResult, { fetchMoreResult }) => {
  const response = {
    ...fetchMoreResult,
    customers: {
      ...fetchMoreResult.customers,
      count: fetchMoreResult.customers.count,
      cursor: fetchMoreResult.customers.cursor,
      results: [
        ...previousResult.customers.results,
        ...fetchMoreResult.customers.results
      ],
      __typename: previousResult.customers.__typename
    }
  }
  return response
}

const Customers = ({ children, ...props }) => {
  return (
    <QueryManager query={GET_CUSTOMERS} {...props}>
      {({ data, loading, fetchMore }) =>
        children({
          data: get(data, 'customers.results', []),
          count: get(data, 'customers.count'),
          loading,
          fetchMore: ({ pageSize }) => fetchMore({
            query: GET_CUSTOMERS,
            variables: { cursor: get(data, 'customers.cursor'), size: pageSize },
            updateQuery: onFetchMoreResponse
          })
        })}
    </QueryManager>
  )
}

Customers.propTypes = {
  children: PropTypes.any
}

export default Customers
